var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyApiKeys(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 109,
    viewBox: "0 0 114 109",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M110.51 105.319C108.6 107.233 105.501 107.235 103.589 105.323L90.9229 92.6554L97.8362 85.7266L110.507 98.398C112.417 100.308 112.419 103.406 110.51 105.319Z",
    stroke: "#076F3E",
    strokeWidth: 3.41347,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M89.1982 83.998L93.8494 88.6597",
    stroke: "#076F3E",
    strokeWidth: 3.41347,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M72.5831 39.4677V21.7587L55.4865 2H12.474C6.7221 1.99978 2.05933 6.63564 2.05933 12.3544V89.2379C2.05933 94.9566 6.7221 99.5925 12.474 99.5925H62.1684C67.4064 99.5925 71.7411 95.748 72.4739 90.7426",
    stroke: "#E4E4E4",
    strokeWidth: 3.41347,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6721 47.287H53.5343",
    stroke: "#E4E4E4",
    strokeWidth: 3.41347,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6721 58.5945H45.9256",
    stroke: "#E4E4E4",
    strokeWidth: 3.41347,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6721 35.9797H57.6961",
    stroke: "#E4E4E4",
    strokeWidth: 3.41347,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6721 24.6724H41.2585",
    stroke: "#E4E4E4",
    strokeWidth: 3.41347,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M55.4861 2.89284V21.7583H71.6895",
    stroke: "#E4E4E4",
    strokeWidth: 3.41347,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5058 72.2187H18.6721V85.8052H55.6588",
    stroke: "#E4E4E4",
    strokeWidth: 3.41347,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M76.9038 59.4345L64.7124 71.6986",
    stroke: "#FF725E",
    strokeWidth: 3.41347,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M76.9038 71.6986L64.7124 59.4345",
    stroke: "#FF725E",
    strokeWidth: 3.41347,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M70.808 90.2983C84.4364 90.2983 95.4844 79.2255 95.4844 65.5665C95.4844 51.9075 84.4364 40.8347 70.808 40.8347C57.1796 40.8347 46.1316 51.9075 46.1316 65.5665C46.1316 79.2255 57.1796 90.2983 70.808 90.2983Z",
    stroke: "#00A657",
    strokeWidth: 3.41347,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyApiKeys);
export default __webpack_public_path__ + "static/media/empty-api-keys.6c5444d3135dd272c1fe6740d32f7aab.svg";
export { ForwardRef as ReactComponent };